import { render, staticRenderFns } from "./RelatedProductsWidget.vue?vue&type=template&id=4150ea1c&scoped=true&"
import script from "./RelatedProductsWidget.vue?vue&type=script&lang=js&"
export * from "./RelatedProductsWidget.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductsWidget.vue?vue&type=style&index=0&id=4150ea1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4150ea1c",
  null
  
)

export default component.exports